import BaseModel from "../default/base-model";

export class ImportRelatedCost extends BaseModel{
    id: number;
    client: number;
    status: StatusImportRelatedCost;
    user: string;
    report?: File;
    error_message?: string;


    constructor() {
        super();
        this.id = 0;
        this.client = 0;
        this.status = 0;
        this.user = '';
        this.report = undefined;
        this.error_message = '';
    }
}

export enum StatusImportRelatedCost {
    PROCESSING = 1,
    COMPLETED = 2,
    FAIL = 3,
}

export const StatusImportRelatedCostLabel = {
    [StatusImportRelatedCost.PROCESSING]: {label: 'processing', color: 'info'},
    [StatusImportRelatedCost.COMPLETED]: {label: 'processed', color: 'success'},
    [StatusImportRelatedCost.FAIL]: {label: 'fail_to_process', color: 'error'},
};
